import { place, type RoomContext, type RoomDecorator } from '../index';
import * as kit from '../../medieval-office-kit';

const decorate: RoomDecorator = (ctx: RoomContext) => {
  const { art, f } = ctx;

  // Warm tavern floor runner under the central gathering space.
  place(ctx, f.rug(art, 220, 150), 520, 1010);

  // HERO: ale-bar on the south wall, with its row of barstools facing it (south).
  place(ctx, kit.aleBar(art, 150), 480, 1122);
  for (const sx of [430, 480, 530]) place(ctx, kit.woodStool(art), sx, 1095);

  // Fireside nook in the NW corner (clear of the north door gap 460..580).
  place(ctx, kit.fireplace(art, 80), 408, 904);
  place(ctx, kit.woodChair(art, Math.PI), 615, 1075); // fireside armchair, faces west

  // Cellar dressing — barrels of ale and hops climbing the wall.
  place(ctx, kit.barrel(art), 632, 924);
  place(ctx, kit.barrel(art), 640, 1090);
  place(ctx, f.plant(art, 'leafy'), 632, 990);

  // Overhead light + a wall torch to keep the room golden and merry.
  place(ctx, kit.candelabra(art), 520, 975);
  place(ctx, kit.wallTorch(art), 392, 1000);
};

export default decorate;
